import { PathBuilder, ApiRoute, HttpMethod, ServerRoute } from '../common';
import { PrintProviderSKUId } from '../printProvider';
import { BaseLocationPublishParams } from './publishApiCommon';

export interface ShoppingCartData {
    count: number;
}

export interface GetShoppingCartResponse {
    shoppingCart: ShoppingCartData | null;
}

export interface UpdateShoppingCartBody {
    uploadUrl: string;
    quantity: number;
    sku: string;
    editableTextContent: string[];
}

export interface GetQuantityOptionsParams extends BaseLocationPublishParams {
    skuId: PrintProviderSKUId;
}

export interface Four51QuantityOption {
    quantity: number;
    priceAmountInCents: number;
    label: string;
}

export interface GetQuantityOptionsLinearResponse {
    linearPricing: true;
    priceAmountInCents: number;
}

export interface GetQuantityOptionsNonLinearResponse {
    linearPricing: false;
    quantityOptions: Four51QuantityOption[];
}

export type GetQuantityOptionsResponse = GetQuantityOptionsLinearResponse | GetQuantityOptionsNonLinearResponse;

const FOUR51_PUBLISH_API_ROOT = <TParams extends BaseLocationPublishParams>(path: PathBuilder<TParams>) =>
    path.literal('publish').literal('four51').literal('location').param('locationId');

export const Four51Api = {
    getQuantityOptions: new ApiRoute<GetQuantityOptionsResponse, GetQuantityOptionsParams, void, void>(
        HttpMethod.Get,
        path => FOUR51_PUBLISH_API_ROOT(path).literal('sku').param('skuId').literal('quantityOptions'),
    ),
    getShoppingCart: new ApiRoute<GetShoppingCartResponse, BaseLocationPublishParams, void, void>(
        HttpMethod.Get,
        path => FOUR51_PUBLISH_API_ROOT(path).literal('cart'),
    ),
    logonToFour51: new ServerRoute<BaseLocationPublishParams, void>(path =>
        FOUR51_PUBLISH_API_ROOT(path).literal('login'),
    ),
};
